import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { setLoggedin } from "./userSlice";
// import { setLoggedin, setLogin } from "./userSlice";

const initialState = {
    isLoading: false,
    isResending: false,
    signUpData: {},
    forgotPasswordData: {},
    resetPasswordData: {},
    verifyOtpData: {},
    verifyLoginData: {},
    loginData: {},
    errorMsg: "",
    isError: false
}

export const createAccount = createAsyncThunk('createAccount', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.createAccount(body);
        dispatch(setLoading(true))        

        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setSignUp(body))
                Toastify.success("OTP sent successfully");
                // localStorage.setItem("token",data.data.token)

        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const verifyOtp = createAsyncThunk('verifyOtp', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.verifyOtp(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLoggedin(true))
                Toastify.success("OTP Verified successfully");
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const resendOtpForSignUp = createAsyncThunk('resendOtpForSignUp', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.resendOtpForSignUp(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                // dispatch(setLoggedin(true))
                Toastify.success("OTP Resent successfully");
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

//we are not using this
export const login = createAsyncThunk('loginwithmail', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.login(body);
        dispatch(setLoading(true))
        

        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLogin(body))
                Toastify.success("OTP sent successfully");
                // localStorage.setItem("token",data.data.token)
                 return status
        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const verifyLogin = createAsyncThunk('verifyLogin', async (body, { rejectWithValue, dispatch }) => {
    try {
       
     
        const { data, status } = await api.verifyLogin(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLoggedin(true))
                Toastify.success("Logged in successfully");
                localStorage.setItem("email",body.email)
                localStorage.setItem("token",data.data.token)
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

//We are using this api for login with phone
export const loginWithPhone = createAsyncThunk('login', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.loginWithPhone(body);
        dispatch(setLoading(true))
        

        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLogin(body))
                Toastify.success(data?.data?.message || "OTP sent successfully");
                // localStorage.setItem("token",data.data.token)
                 return status
        }
    } catch (err) {
        dispatch(setLoading(false))
        const message = err.response?.data?.message || "Something went wrong. Please try again later.";
        Toastify.error(message);
        return rejectWithValue(message)
    }
}
)
export const verifyLoginWithPhone = createAsyncThunk('verifyLogin', async (body, { rejectWithValue, dispatch }) => {
    try {
       
     
        const { data, status } = await api.verifyLoginWithPhone(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setLoggedin(true))
                Toastify.success("Logged in successfully");
                localStorage.setItem("phone",body.phone)
                localStorage.setItem("token",data.data.token)
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const resendOtpForLogin = createAsyncThunk('resendOtpForLogin', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.resendOtpForLogin(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                // dispatch(setLoggedin(true))
                Toastify.success("OTP Resent successfully");
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const resendOtpForLoginWithEmail = createAsyncThunk('resendOtpForLogin', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.resendOtpForLoginWithEmail(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                // dispatch(setLoggedin(true))
                Toastify.success("OTP Resent successfully");
        }
        return status
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        // return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const resetPassword = createAsyncThunk('verifyOtp', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.resetPassword(body);
        dispatch(setLoading(true))
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setResetPassword(body))
                Toastify.success("Password Reset Successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setSignUp: (state, action) => {
            state.signUpData = action.payload
        },
        setLogin: (state, action) => {
            state.loginData = action.payload
        },
        setVerifyLogin: (state, action) => {
            state.verifyLoginData = action.payload
        },
        setVerifyOtp: (state, action) => {
            state.verifyOtpData = action.payload
        },
        setResetPassword: (state, action) => {
            state.resetPasswordData = action.payload
        },
        
    },
    
})

export const { setLoading,setSignUp,setVerifyLogin, setVerifyOtp,setResetPassword,setLogin} = loginSlice.actions

export default loginSlice.reducer;
